module.exports = __webpack_public_path__ + "img/nav_4.2db2043b.png";